import React from 'react';
import styled from 'styled-components';

const SwitchContainer = styled.div`
  display: flex;
  width: 40px;
  padding: 2px;
  justify-content: ${({ $isOn }) => ($isOn ? 'flex-end' : 'flex-start')};
  align-items: center;
  gap: 4px;
  border-radius: 100px;
  background: ${({ $isOn, theme }) =>
    $isOn ? theme.primary.primary : theme.border.secondary};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
`;

const Circle = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: ${({ theme }) => theme.background.primary};
  transition: all 0.2s ease-in-out;
`;

const Switch = ({ isOn, onToggle, disabled }) => {
  return (
    <SwitchContainer
      $isOn={isOn}
      onClick={() => !disabled && onToggle(!isOn)}
      style={{
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <Circle />
    </SwitchContainer>
  );
};

export default Switch;
